import React from 'react';
import '../../assets/styles/footer.css';

const Footer = () => {
  // Add JSON-LD schema for better SEO
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Matrix IT",
    "description": "Matrix IT is an IT solutions provider based in Cuttack, Odisha, offering laptop & desktop sales, server infrastructure, networking, AMC, and cybersecurity services.",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Link Rd, Surya Vihar",
      "addressLocality": "Cuttack",
      "addressRegion": "Odisha",
      "postalCode": "753012",
      "addressCountry": "IN"
    },
    "email": "info@matrixit.co.in",
    "telephone": "+919338461233",
    "url": "https://www.matrixit.co.in",
    "sameAs": [
      "https://facebook.com",
      "https://twitter.com",
      "https://linkedin.com"
    ]
  };

  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
      <footer className="footer" itemScope itemType="https://schema.org/Organization">
        <div className="footer-content">
          <div className="footer-section about">
            <h3>About Us</h3>
            <p itemProp="description">
              Matrix IT is your trusted IT solutions provider in Cuttack, Odisha, offering comprehensive services including laptop & desktop sales, server infrastructure, networking, AMC, and cybersecurity to ensure seamless business operations.
            </p>
            <div className="footer-logo">
              <span itemProp="name">Matrix IT</span>
            </div>
          </div>
        </div>
        <div className="footer-section quick-links">
          <h3>Quick Links</h3>
          <ul>
            <li><a href="/about">About Us</a></li>
            <li><a href="/services">Services</a></li>
            <li><a href="/products">Products</a></li>
            <li><a href="/contact">Contact</a></li>
            <li><a href="/privacy-policy">Privacy Policy</a></li>
          </ul>
        </div>
        <div className="footer-section contact">
          <h3>Contact</h3>
          <p>Email: <a href="mailto:info@matrixit.co.in" itemProp="email">info@matrixit.co.in</a></p>
          <p>Phone: <a href="tel:+919338461233" itemProp="telephone">+91 9338461233</a></p>
          <p>Website: <a href="https://www.matrixit.co.in" target="_blank" rel="noopener noreferrer">www.matrixit.co.in</a></p>
          <p itemProp="address" itemScope itemType="https://schema.org/PostalAddress">
            <span itemProp="streetAddress">Link Rd, Surya Vihar</span>,{' '}
            <span itemProp="addressLocality">Cuttack</span>,{' '}
            <span itemProp="addressRegion">Odisha</span>{' '}
            <span itemProp="postalCode">753012</span>
          </p>
        </div>
        <div className="footer-section follow-us">
          <h3>Follow Us</h3>
          <div className="social-links">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <span className="social-icon">📘</span> Facebook
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
              <span className="social-icon">🐦</span> Twitter
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <span className="social-icon">💼</span> LinkedIn
            </a>
          </div>
        </div>
        <div className="footer-section newsletter">
          <h3>Newsletter</h3>
          <p>Stay updated with our latest news and offers.</p>
          <form className="newsletter-form">
            <input
              type="email"
              placeholder="Enter your email"
              required
              aria-label="Email for newsletter"
            />
            <button type="submit" className="subscribe-button">Subscribe</button>
          </form>
        </div>
                <div className="footer-bottom">
  <p>© {new Date().getFullYear()} Matrixit. All rights reserved.</p>

  <p
    style={{
      marginTop: "8px",
      fontSize: "14px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: "6px",
      flexWrap: "wrap"
    }}
  >
    Made with{" "}
    <span
      style={{
        color: "red",
        fontSize: "16px",
        display: "inline-flex",
        alignItems: "center"
      }}
    >
      ❤️
    </span>{" "}
    by{" "}
    <a
      href="https://odi-web.vercel.app"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        color: "inherit",
        textDecoration: "none",
        fontWeight: "600"
      }}
    >
      Odiweb
    </a>
  </p>
</div>
      </footer>
      
    </>
  );
};

export default Footer;
